<template>
  <div>
    <!-- 配送单删除-填写删除原因 -->
    <el-dialog :title="$t('message.enterReasonForDeletion')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="520px" center>
      <div class="content">

        <div class="textarea">
          <el-input type="textarea" v-model="delData.delete_reason" show-word-limit resize="none"
            onfocus="this.select()">
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="deletePorder">{{
          $t("message.delete")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {

  data() {
    return {
      dialogVisible: false,
      delData: {
        delete_reason: "",
        porder_sn: '',
      }
    };
  },
  methods: {
    // 保存
    deletePorder() {
      if (!this.delData.delete_reason) {
        this.$message.error(this.$t("message.pleaseEnterTheDeReason"));
        return;
      }

      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.porderApi.deletePorder(this.delData).then((res) => {
            this.$message.success(res.msg);
            this.$parent.generalList();
            this.dialogVisible = false
          });
        })
        .catch(() => { });

    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  padding: 0 30px;

  h6 {
    font-size: 18px;
    margin-bottom: 20px;
  }

  .row {
    display: flex;
    margin-bottom: 12px;

    i {
      margin-left: 20px;
      font-size: 25px;
      line-height: 40px;
      cursor: pointer;
    }
  }
}

/deep/ .el-checkbox-group {
  .el-checkbox {
    margin: 0 50px 20 0 !important;
  }
}
</style>